import { CarrierTable } from "./views/CarrierTable";
import {
  carrierAddState,
  carrierContactMassUploadState,
  carrierEditState,
  carrierMassUploadState,
  carrierShowState,
  filteredCarrierData,
  isCarrierFiltered,
  selectedCarriers,
} from "./atom/atoms";
import { useRecoilState } from "recoil";
import CarrierTitleHeader from "./views/CarrierTitleHeader";
import CarrierMainFilter from "./views/CarrierMainFilter";
import CarrierActionGroup from "./views/CarrierActionGroup";
import CarrierForm from "./forms/CarrierForm";
import { ICarriers, IStatesOptions } from "./types";
import MassUpload from "./massupload/MassUpload";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGetAllCarriers } from "./hooks/useGetAllCarriers";

const CarrierModule = () => {
  let location = useLocation();
  const [isShow, setCarrierShow] = useRecoilState(carrierShowState);
  const [addStatus, setCarrierAdd] = useRecoilState(carrierAddState);
  const [editStatus, setEditCarrier] = useRecoilState(carrierEditState);
  const [filteredCarrier, setFilteredCarrier] =
    useRecoilState<Array<ICarriers>>(filteredCarrierData);
  const [isFiltered, setIsFiltered] = useRecoilState<true | false>(
    isCarrierFiltered
  );
  const [, setSelectedCarrierIds] =
    useRecoilState<Array<IStatesOptions>>(selectedCarriers);
  const [carrierMassUpload, setCarrierMassUploadd] = useRecoilState(
    carrierMassUploadState
  );
  const [contactMassUpload, setContactMassUpload] = useRecoilState(
    carrierContactMassUploadState
  );

  //default statuses
  useEffect(() => {
    setCarrierShow(false);
    setCarrierAdd(false);
    setEditCarrier(false);
    setIsFiltered(false);
    setCarrierMassUploadd(false);
    setContactMassUpload(false);
    setSelectedCarrierIds([]);
  }, []);

  //Hook to get carrier data for main table.
  const {
    data: allCarriersData,
    isLoading: carrierLoading,
    refetch: refetchCarriers,
  } = useGetAllCarriers();

  let recordIdFromRecent = { moduleName: "", state: null } as any;
  let redirectionFromReport = "" as any;
  if (location.state != null) {
    recordIdFromRecent = location.state;
    redirectionFromReport = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent?.moduleName === "Carrier" && allCarriersData) {
      try {
        setIsFiltered(true);
        const recordId = recordIdFromRecent?.recordId.split(".");
        const filtered = allCarriersData.filter((carrier) =>
          recordId.includes(carrier.masterCarrierId?.toString())
        );
        setFilteredCarrier(filtered.map((data) => ({ ...data })));
        const selectedCarrier = filtered.map((c) => {
          return { label: c.carrierName, value: c.masterCarrierId };
        }) as unknown as Array<IStatesOptions>;
        setSelectedCarrierIds(selectedCarrier);
      } catch (error) {}
    } else if (
      redirectionFromReport?.action === "carrierE&o" &&
      allCarriersData
    ) {
      setIsFiltered(true);
      const filtered = allCarriersData.filter(
        (carrier) => carrier.carrierName === redirectionFromReport?.carrierName
      );
      setFilteredCarrier(filtered.map((data) => ({ ...data })));
      const selectedCarrier = filtered.map((c) => {
        return { label: c.carrierName, value: c.masterCarrierId };
      }) as unknown as Array<IStatesOptions>;
      setSelectedCarrierIds(selectedCarrier);
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [allCarriersData]);

  return (
    <div className="px-8 py-4">
      {!addStatus && !editStatus && !isShow && (
        <div>
          <CarrierTitleHeader />
          <div className="pt-4 flex flex-row justify-between space-x-4 pb-2">
            <div className="z-20" style={{ width: "310px" }}>
              {allCarriersData && (
                <CarrierMainFilter
                  carriersData={allCarriersData}
                  isCarrierLoading={carrierLoading}
                />
              )}
            </div>
            <div className="">
              <CarrierActionGroup
                carriersData={
                  isFiltered
                    ? filteredCarrier.map((data) => ({ ...data }))
                    : allCarriersData
                }
              />
            </div>
          </div>
        </div>
      )}
      {(carrierMassUpload || contactMassUpload) && (
        <MassUpload
          isOpen={carrierMassUpload || contactMassUpload}
          isForMassUploadCarrier={carrierMassUpload}
          refetchGetCarriers={refetchCarriers}
        />
      )}
      {/* {!addStatus && !editStatus && ( */}
      <div className={`${addStatus || editStatus ? "hidden" : "block"}`}>
        <CarrierTable
          carriersData={
            isFiltered
              ? filteredCarrier.map((data) => ({ ...data }))
              : allCarriersData
          }
          getCarrierLoading={carrierLoading}
        />
      </div>
      {/* )} */}
      {(addStatus || editStatus) && !isShow && (
        <CarrierForm refetchGetCarriers={refetchCarriers} />
      )}
    </div>
  );
};

export default CarrierModule;
